module.exports = __webpack_public_path__ + "img/148.f4f3cee7.png";